<template>
    <span>
        <div class="toolbar">
            <b-button
                class="mr-1"
                size="sm"
                :disabled="showSource || !focusIn"
                variant="dark"
                @mousedown="showLinkModal(true)"
            >
                <font-awesome-icon :icon="['fas', 'link']" size="sm"></font-awesome-icon>
            </b-button>
            <b-button v-if="!showSource" size="sm" variant="dark" @click="toggleShowSource()"> Show Source </b-button>
            <b-button v-if="showSource" size="sm" variant="dark" @click="toggleShowSource()"> Show HTML </b-button>
        </div>
        <b-form-group :label="label" :description="description" :invalid-feedback="error" :state="state">
            <contenteditable
                v-on="listeners"
                v-bind="attrs"
                id="lx-text-editor"
                ref="ced"
                v-if="!showSource"
                tag="span"
                :contenteditable="true"
                :value="value"
                :state="state"
                :noNL="false"
                :noHTML="false"
                @focus="focus"
                @blur="blur"
                :class="['email-message-html-editor', 'form-control', error ? 'is-invalid' : '']"
                @input="input"
                @click="onClick"
            ></contenteditable>
            <b-form-textarea
                v-on="listeners"
                v-bind="attrs"
                v-if="showSource"
                :value="value"
                :class="['email-message-html-editor', error ? 'is-invalid' : '']"
                :error="error"
                @input="input"
            ></b-form-textarea>
        </b-form-group>
        <validation-observer v-slot="{ meta }">
            <modal
                id="insert-link-modal"
                title="Edit Link"
                ok-title="Set Link"
                :okDisabled="!meta.valid"
                @ok="setLink"
                @hide="onHide"
                :static="true"
                no-fade
            >
                <b-form>
                    <b-row>
                        <b-col>
                            <validation-provider name="linkText" v-slot="{ errors, handleChange }" rules="required">
                                <form-input
                                    @input="handleChange"
                                    v-model="linkText"
                                    :error="errors[0]"
                                    floating-label="Text"
                                ></form-input>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <validation-provider
                                name="linkURL"
                                v-slot="{ errors, handleChange }"
                                rules="required|validUrl"
                            >
                                <form-input
                                    @input="handleChange"
                                    v-model="linkURL"
                                    :error="errors[0]"
                                    floating-label="URL"
                                ></form-input>
                            </validation-provider>
                        </b-col>
                    </b-row>
                </b-form>
            </modal>
        </validation-observer>
    </span>
</template>

<script>
import { formFieldMixin } from '../../../mixins/form-field-mixin';
import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
import FormInput from '../form-input/form-input.vue';
import Modal from '../modal/modal.vue';

export default {
    name: 'LxEditor',
    mixins: [formFieldMixin, removeScrollMixin],
    components: {
        FormInput,
        Modal,
    },
    props: {
        value: [String, Number],
    },
    data() {
        return {
            showSource: false,
            linkText: '',
            linkURL: '',
            range: null,
            element: null,
            focusIn: false,
        };
    },
    created() {
        this.resetSetLinkModal();
    },
    methods: {
        onClick(e) {
            if (e.target.tagName.toLowerCase() === 'a') {
                this.linkText = e.target.innerHTML;
                this.linkURL = e.target.href;
                this.element = e.target;
                this.showLinkModal();
            }
        },
        focus() {
            this.focusIn = true;
        },
        blur() {
            this.focusIn = false;
        },
        showLinkModal(isInsert) {
            if (isInsert) {
                this.range = window.getSelection().getRangeAt(0);
                if (this.range.startContainer.parentNode.id != 'lx-text-editor') {
                    return;
                }
                this.element = null;
                this.resetSetLinkModal();
            } else {
                this.range = null;
            }
            this.$bvModal.show('insert-link-modal');
        },
        setLink() {
            if (this.range != null) {
                let a = document.createElement('a');
                a.appendChild(document.createTextNode(this.linkText));
                a.href = this.linkURL;
                this.range.deleteContents();
                this.range.insertNode(a);
            } else if (this.element != null) {
                this.element.innerHTML = this.linkText;
                this.element.href = this.linkURL;
            }
            this.$refs.ced.$el.focus();
        },
        toggleShowSource() {
            this.$nextTick(() => {
                this.showSource = !this.showSource;
            });
        },
        resetSetLinkModal() {
            this.linkText = 'Link Text';
            this.linkURL = 'https://www.lodgix.com';
        },
        onHide() {
            this.resetSetLinkModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.toolbar {
    border: 1px solid #ced4da;
    border-bottom: 0;
    box-sizing: border-box;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    padding: 8px;
}

.email-message-html-editor {
    min-height: 150px;
    border: 1px solid #ced4da;
    border-bottom-left-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
    padding: 10px;
    height: auto !important;
    overflow-x: auto;
    //white-space: pre-wrap;
}

:deep(.email-message-html-editor a) {
    cursor: pointer !important;
}

:deep(.is-invalid) {
    background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem) !important;
}
</style>
